<template>
  <div class="compound public-content">
    <div class="breadcrumb">白页管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 5px 0 0 ">白页名称: </span>
        <el-input v-model="searchWhitePageVO.whitePageName" maxlength="20" placeholder="请输入白页名称"></el-input>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
        <el-button round type="primary" v-permission="'pts:admin:white:add'" @click="openAddWhitePageDialog">添加白页</el-button>
        <el-button round type="primary" @click="positionDialogVisible = true">添加白页位置</el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="白页名称" min-width="100px" prop="whitePageName"></el-table-column>
          <el-table-column label="白页出现位置" min-width="100px" prop="sizeName">
            <template slot-scope="scope">
              <p>封面：{{ getWhitePositionName(scope.row.whitePageCoverPosition) }}</p>
              <p>内页：{{ getWhitePositionName(scope.row.whitePageTextPosition) }}</p>
              <p>单页：{{ getWhitePositionName(scope.row.whitePageSinglePosition) }}</p>
            </template>
          </el-table-column>
          <el-table-column label="填充色值" min-width="100px" prop="colorValue"></el-table-column>
          <el-table-column label="操作" min-width="100px">
            <template v-slot="scope">
              <span class="color-blue" v-permission="'pts:admin:white:delete'" @click="deleteId = scope.row.id, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 添加白页 -->
    <el-dialog :close-on-click-modal="false" title="白页设置" @closed='closed' :visible.sync="dialogVisible" width="30%">
      <el-form hide-required-asterisk :model="addWhitePageVO" ref="addRefs" :rules="addRules" label-width="120px">
        <el-form-item label="白页名称:" prop="whitePageName">
          <el-input v-model="addWhitePageVO.whitePageName" maxlength="20" placeholder="请输入白页名称" style="width:229px"></el-input>
        </el-form-item>
        <el-form-item label="白页出现位置:" class="bbbbb">
          <el-form-item label="" label-width="0" prop="whitePageCoverPosition">
            <span class="aaaaa">封面:</span>
            <el-select clearable v-model="addWhitePageVO.whitePageCoverPosition" placeholder="请选择">
              <el-option v-for="item in whitePositionList" :key="'封面' + item.id" :label="item.dictValue" :value="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin:20px 0" label="" label-width="0" prop="whitePageTextPosition">
            <span class="aaaaa">内页:</span>
            <el-select clearable v-model="addWhitePageVO.whitePageTextPosition" placeholder="请选择">
              <el-option v-for="item in whitePositionList" :key="'内页' + item.id" :label="item.dictValue" :value="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" label-width="0" prop="whitePageSinglePosition">
            <span class="aaaaa">单页:</span>
            <el-select clearable v-model="addWhitePageVO.whitePageSinglePosition" placeholder="请选择">
              <el-option v-for="item in whitePositionList" :key="'单页' + item.id" :label="item.dictValue" :value="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="填充色值:" prop="colorValue">
          <span class="aaaaa">#</span>
          <el-input v-model="addWhitePageVO.colorValue" maxlength="20" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addWhitePage">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加白页位置 -->
    <el-dialog :close-on-click-modal="false" title="添加白页位置" @closed="positionClosed" :visible.sync="positionDialogVisible" width="30%">
      <el-form hide-required-asterisk :model="addPositionVO" ref="positionRef" :rules="positionRules" label-width="120px">
        <el-form-item label="白页位置名称:" prop="positionName">
          <el-input v-model="addPositionVO.positionName" maxlength="20" placeholder="请输入白页位置名称" style="width:229px"></el-input>
        </el-form-item>
        <el-form-item label="白页位置页序:" prop="positionSort">
          <el-input v-model="addPositionVO.positionSort" maxlength="20" placeholder="请输入白页位置页序" style="width:229px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="positionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addWhitePagePosition">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该白页？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteWhitePage(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index'
import { whitePageList, whitePageAdd, whitePageDelete, whitePosition, whitePageUsable, dictionarySave } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      dialogVisible: false,
      positionDialogVisible: false,
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      tableData: [],
      searchWhitePageVO: {
        whitePageName: ''
      },
      addWhitePageVO: {
        colorValue: null,
        whitePageCoverPosition: '',
        whitePageName: '',
        whitePageSinglePosition: '',
        whitePageTextPosition: ''
      },
      addRules: {
        whitePageName: [
          { required: true, message: '请输入白页名称', trigger: 'blur' }
        ],
        whitePageTextPosition: [
          { required: true, message: '请选择内页位置', trigger: 'change' }
        ],
        whitePageCoverPosition: [
          { required: true, message: '请选择封面位置', trigger: 'change' }
        ],
        whitePageSinglePosition: [
          { required: true, message: '请选择单页位置', trigger: 'change' }
        ]
      },
      whitePositionList: [],
      addPositionVO: {
        positionName: '',
        positionSort: ''
      },
      positionDictKey: 'WHITE_PAGE'
    }
  },
  computed: {
    positionRules () {
      return {
        positionName: [
          { required: true, message: '请输入白页位置名称', trigger: 'blur' }
        ],
        positionSort: [
          { required: true, message: '请输入白页位置页序', trigger: 'blur' },
          { validator: this.validatePositionSort, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.onSubmit()
    this.getWhitePositionList()
  },
  methods: {
    getWhitePositionName (dictCode) {
      if (!dictCode) return '未定义'
      const item = this.whitePositionList.find(i => i.dictCode === dictCode)
      return item ? item.dictValue : '未定义'
    },
    openAddWhitePageDialog () {
      this.dialogVisible = true
      this.getWhitePositionList()
    },
    closed () {
      this.addWhitePageVO = {
        colorValue: null,
        whitePageCoverPosition: '',
        whitePageName: '',
        whitePageSinglePosition: '',
        whitePageTextPosition: ''
      }
      this.$refs.addRefs.resetFields()
    },
    getWhitePositionList () {
      whitePosition().then(res => {
        if (res.data.success) {
          this.whitePositionList = res.data.data
        }
      })
    },
    deleteWhitePage (id) {
      whitePageDelete(id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    addWhitePage () {
      this.$refs.addRefs.validate((valid) => {
        if (!valid) {
          return
        }
        whitePageUsable({ act: 0, whitePageName: this.addWhitePageVO.whitePageName }).then(res => {
          if (res.data.success) {
            whitePageAdd(this.addWhitePageVO).then(res => {
              if (res.data.success) {
                this.$message.success('创建成功')
                this.onSubmit()
                this.dialogVisible = false
              }
            })
          }
        })
      })
    },
    onSubmit () {
      whitePageList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchWhitePageVO: this.searchWhitePageVO }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.onSubmit(this.queryInfo)
          }
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    positionClosed () {
      this.addPositionVO = {
        positionName: '',
        positionSort: ''
      }
      this.$refs.positionRef && this.$refs.positionRef.resetFields()
    },
    validatePositionSort (_rule, value, callback) {
      if (!value) {
        callback(new Error('请输入白页位置页序'))
        return
      }
      // 检查是否包含中文逗号
      if (value.indexOf('，') !== -1) {
        callback(new Error('页序间隔请使用英文逗号","，不能使用中文逗号'))
        return
      }
      // 检查格式：只允许数字和英文逗号，且以数字开头和结尾
      if (!/^\d+(,\d+)*$/.test(value)) {
        callback(new Error('页序格式错误，请使用数字+英文逗号间隔，如：2,4,3'))
        return
      }
      callback()
    },
    addWhitePagePosition () {
      this.$refs.positionRef.validate((valid) => {
        if (!valid) return
        dictionarySave(this.positionDictKey, this.addPositionVO.positionName, this.addPositionVO.positionSort).then(res => {
          if (res.data.success) {
            this.$message.success('添加成功')
            this.positionDialogVisible = false
            this.getWhitePositionList()
          }
        })
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.bbbbb {
  @{deep} .el-input__inner {
    border-radius: 0 5px 5px 0;
  }
}

.aaaaa {
  width: 49px;
  height: 30px;
  position: relative;
  top: 1px;
  box-sizing: border-box;
  text-align: center;
  display: inline-block;
  background-color: rgba(249, 249, 249, 1);
  // border-color: rgba(228, 228, 228, 1);
  color: #bbbbbb;
  border-radius: 5px 0 0 5px;
  border: 1px solid #dcdfe6;
  border-right: none;
}

.compound {
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
